'use es6';

import { Record } from 'immutable';
const SequenceDetailsRecord = Record({
  entity: null,
  report: null,
  trackingStatus: null,
  attractStageCampaign: null,
  convertStageCampaign: null,
  closeStageCampaign: null,
  stageAutomationStatusByCampaignId: null
});
export default SequenceDetailsRecord;